import { Link } from 'react-router-dom'
import { Camera } from 'lucide-react'
import {
  LATEST_UPDATE_PROMO_BODY,
  LATEST_UPDATE_PROMO_CTA,
  LATEST_UPDATE_PROMO_HEADLINE,
  LATEST_UPDATE_PROMO_PATH,
  type LatestUpdatePromoSurface,
} from '../content/latest-update-promo'

type LatestUpdatePromoBannerProps = {
  surface: LatestUpdatePromoSurface
  /**
   * When true, add top margin to clear the fixed nav (64px). Use on the authenticated homepage.
   */
  offsetForFixedNav?: boolean
}

export function LatestUpdatePromoBanner({
  surface,
  offsetForFixedNav = false,
}: LatestUpdatePromoBannerProps) {
  if (!surface) return null

  return (
    <div
      role="region"
      aria-label={LATEST_UPDATE_PROMO_HEADLINE}
      className={`border-b border-primary-200/90 bg-gradient-to-r from-primary-50 to-primary-100/80 ${offsetForFixedNav ? 'mt-16' : ''}`}
    >
      <div className="container-max px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <div className="flex gap-3 min-w-0">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/90 shadow-sm ring-1 ring-primary-200/60">
              <Camera className="h-5 w-5 text-primary-600" aria-hidden />
            </div>
            <div className="min-w-0 pt-0.5">
              <p className="font-serif text-base font-semibold text-primary-900 sm:text-lg">
                {LATEST_UPDATE_PROMO_HEADLINE}
              </p>
              <p className="mt-0.5 text-sm text-neutral-700 leading-snug sm:text-[0.9375rem] sm:leading-relaxed">
                {LATEST_UPDATE_PROMO_BODY}
              </p>
            </div>
          </div>
          <Link
            to={LATEST_UPDATE_PROMO_PATH}
            className="shrink-0 inline-flex items-center justify-center rounded-lg bg-primary-600 px-4 py-2.5 text-center text-sm font-semibold text-white shadow-sm transition-colors hover:bg-primary-700 sm:px-5"
          >
            {LATEST_UPDATE_PROMO_CTA}
          </Link>
        </div>
      </div>
    </div>
  )
}
